import { Deserializable } from '../deserializable';

export class UserTradingSearchRequest implements Deserializable {
  public searchTerm: string = '';
  public entityType: number;
  public entityId: number;
  public orderBy: string = 'Full Name';
  public orderDirection: string = 'ASC';
  public bankId: number;
  public minBalance: number = 90000;
  public minArbRate: number = 0.1;
  public accountBalanceDate: string = 'Today';
  public showExcludedUsers: boolean = false;
  public tradeFilter: string = 'All';

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
